/* eslint-disable @typescript-eslint/ban-types */

import styled from 'styled-components';
import getSubjectsType from '../../utils/get-Subject-Types';

interface propTypes {
  subject: string,
  color: number,
  textColor: number,
  hoverColor: number,
  isOpen?: boolean,
  highlighted?: boolean,
  onClick?: Function
}

interface buttonContainerPropTypes {
  highlighted?: boolean
}

export const MainSubjectButton = styled.button<propTypes>`
  font-family: "Museo", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  border: none;
  background-color: ${({ highlighted }) => (highlighted ? '#A648FF' : '#FFFFFF')};
  width: 100%;
  height: 3.5rem;
  display: flex;
  padding: 16px 16px 16px 20px;
  align-items: center;
  ${({ isOpen }) => (isOpen ? 'border-radius: 10px 10px 0 0;' : 'border-radius: 10px;')};
  color: ${({ highlighted }) => (highlighted ? '#FFFFFF' : '#333333')};
  transition: 300ms ease;
  cursor: pointer;
  font-weight: ${({ highlighted }) => (highlighted ? '700' : 500)};
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;

  &:hover {
    background-color: #6EFEE4;
    color: #333333;
  }

  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;

  .subtitle {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const ChildSubjectButton = styled.button<propTypes>`
  font-family: "Museo", sans-serif;
  font-size: 0.875rem;
  font-weight: ${({ highlighted }) => (highlighted ? '700' : 500)};
  line-height: 1.5rem;
  border: none;
  background-color: 
    ${({ highlighted }) => (
      !highlighted ? '#FFFFFF' : '#A648FF')};
  width: 100%;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ isOpen }) => (isOpen ? '10px 10px 0 0;' : '10px;')};
  color: ${({ theme, highlighted }) => (highlighted ? '#FFFFFF' : theme.colors.grayscale[30])}; 
  transition: 300ms ease;
  cursor: pointer;

  &:hover {
    background-color: #6EFEE4;
    color: #333333;
  }
`;

export const ChildrenSubjectsContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const ButtonContainer = styled.div<buttonContainerPropTypes>`
  background-color: ${({ highlighted }) => (highlighted ? '#DDD2FF' : 'none')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px;
`;
